(function () {
    window.gbg = window.gbg || {};
}());
(function () {
    'use strict';
    gbg.Search = (function () {
        // site search modal
        const triggers = document.querySelectorAll('.nav-search');
        const container = document.querySelector('.site-search');
        const searchBox = document.querySelector('#txtSiteSearchInput');
        const resultsContainer = document.querySelector('.site-search__results');
        const resultsWrapper = document.querySelector('.site-search__results-wrapper');
        const closers = document.querySelectorAll('.site-search__close');
        const form = document.querySelector('#formSiteSearch');
        // inline search
        const inlinesearchcontainer = document.querySelector('.inline-search .interactive-search');
        var inlinesearchbox = document.querySelector('.inline-search .interactive-search__input');
        const inlineresultsbox = document.querySelector('.inline-search .interactive-search__results-list');

        var searchTrackTimer;
        var searchStarted = false;
        var filters = [];
        var country = 'en';
        var currentTerm = '';
        var currentResultsCount = 0;
        var currentInlineTerm = '';
        var currentInlineResultsCount = 0;
        var requestSeq = 0;

        var init = function () {
            const countryValue = document.querySelector('#txtSiteSearchC');
            if (countryValue && countryValue.value) {
                country = countryValue.value.toLowerCase();
            } else {
                var pathArray = window.location.pathname.split('/');
                if (pathArray.length > 1 && pathArray[1] !== '') country = pathArray[1];
            }
            // modal
            if (container && searchBox) {
                triggers.forEach(t => t.addEventListener('click', function (e) {
                    e.preventDefault();
                    container.style.visibility = '';
                    container.classList.add('site-search--active');
                    document.body.style.overflow = 'hidden';
                    searchBox.focus();
                }));
                closers.forEach(c => {
                    c.addEventListener('click', closeSearch);
                    c.addEventListener('keyup', function (e) {
                        if (e.key === 'Enter') closeSearch();
                    });
                });
                // click outside the panel closes the modal
                container.addEventListener('click', function (e) {
                    if (!e.target.closest('.site-search__content')) closeSearch();
                });
                document.addEventListener('keyup', function (e) {
                    if (e.key === 'Escape' && container.classList.contains('site-search--active')) closeSearch();
                });
                searchBox.addEventListener('keyup', function (e) {
                    if (e.key === 'Enter') { e.preventDefault(); return false; }
                    getResults(this.value);
                    // GA4: debounce keyed off the keystroke, not the fetch response (see scheduleSearchTracking)
                    scheduleSearchTracking(this.value, 'modal');
                    if (this.value.length > 2 && !searchStarted) {
                        pushEvent('search_started', { search_term: this.value });
                        searchStarted = true;
                    }
                });
                // GA4: result clicks
                resultsContainer.addEventListener('click', function (e) {
                    const link = e.target.closest('a');
                    if (!link) return;
                    e.preventDefault();
                    pushEvent('search_result_click', {
                        search_term: currentTerm,
                        result_page_url: link.href,
                        result_page_title: link.textContent.trim()
                    });
                    setTimeout(function () { window.location = link.href; }, 150);
                });
            }
            // inline search
            if (inlinesearchbox) addInlineSearchEvents();
            if (inlineresultsbox) {
                inlineresultsbox.addEventListener('click', function (e) {
                    const p = e.target.closest('p[data-url]');
                    if (!p) return;
                    e.preventDefault();
                    pushEvent('search_result_click', {
                        search_term: currentInlineTerm,
                        result_page_url: p.dataset.url,
                        result_page_title: p.dataset.title || ''
                    });
                    setTimeout(function () { window.location = p.dataset.url; }, 150);
                });
            }
            document.addEventListener('readystatechange', event => {
                if (event.target.readyState === 'interactive') {
                    var query = gbg.Search.getParameterByName('search');
                    if (query) {
                        if (inlinesearchcontainer && !inlinesearchbox) {
                            var input = document.createElement('input');
                            input.id = 'interactive-search';
                            input.classList.add('interactive-search__input');
                            input.setAttribute('autocomplete', 'off');
                            inlinesearchcontainer.appendChild(input);
                            inlinesearchbox = input;
                            addInlineSearchEvents();
                        }
                        if (inlinesearchbox) {
                            inlinesearchbox.value = query;
                            gbg.Search.doSearch(query, 'full');
                            scheduleSearchTracking(query, 'inline');
                        }
                    }
                }
            });
        };

        // helpers
        function stripHtml(html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html || '';
            return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        }
        // Html 
        function setHighlightedText(el, text, term) {
            el.replaceChildren();
            if (!term) { el.textContent = text; return; }
            const lower = text.toLowerCase();
            const t = term.toLowerCase();
            let pos = 0, idx;
            while ((idx = lower.indexOf(t, pos)) !== -1) {
                el.append(document.createTextNode(text.slice(pos, idx)));
                const span = document.createElement('span');
                span.textContent = text.slice(idx, idx + term.length);
                el.append(span);
                pos = idx + term.length;
            }
            el.append(document.createTextNode(text.slice(pos)));
        }
        function escapeAttr(str) {
            return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
        }
        function setLoading(state) {
            if (form) form.classList.toggle('is-loading', state);
        }

        // GA4
        function sanitizeSearchTerm(term) {
            if (!term) return term;
            return term
                .replace(/[^\s]+@[^\s]+\.[^\s]+/g, '[redacted-email]')
                .replace(/\b\d{7,}\b/g, '[redacted-number]');
        }
        var pushEvent = function (eventName, params) {
            window.dataLayer = window.dataLayer || [];
            const payload = Object.assign({ event: eventName }, params);
            if (typeof payload.search_term === 'string') {
                payload.search_term = sanitizeSearchTerm(payload.search_term);
            }
            window.dataLayer.push(payload);
        };
        function scheduleSearchTracking(term, source) {
            clearTimeout(searchTrackTimer);
            if (!term || term.length < 3) return;
            searchTrackTimer = setTimeout(function () {
                const resultsCount = source === 'inline' ? currentInlineResultsCount : currentResultsCount;
                pushEvent('view_search_results', {
                    search_term: term,
                    results_count: resultsCount
                });
            }, 1200);
        }

        // ===== modal search (Loqate flow) =====
        function closeSearch() {
            container.classList.remove('site-search--active');
            document.body.style.overflow = '';
            searchBox.value = '';
            currentTerm = '';
            requestSeq++;
            setLoading(false);
            clearTimeout(searchTrackTimer);
            resultsContainer.replaceChildren();
            resultsWrapper.classList.remove('site-search__results-wrapper--show');
        }
        async function getResults(search) {
            if (!search || search.length < 3) {
                requestSeq++;
                setLoading(false);
                currentTerm = '';
                currentResultsCount = 0;
                resultsContainer.replaceChildren();
                resultsWrapper.classList.remove('site-search__results-wrapper--show');
                return;
            }
            currentTerm = search;
            const seq = ++requestSeq;
            setLoading(true);
            const url = '/umbraco/surface/sitesearchresults/getpages/?country=' + country
                + '&resultslimiter=none&searchstring=' + encodeURIComponent(search);
            try {
                const response = await fetch(url);
                if (!response.ok) throw new Error('Response status: ' + response.status);
                const json = await response.json();
                if (seq !== requestSeq) return;
                resultsContainer.replaceChildren();
                showResults(json);
            } catch (error) {
                console.error(error.message);
            } finally {
                if (seq === requestSeq) setLoading(false);
            }
        }
        const showResults = function (data) {
            const template = document.getElementById('tmp___site-search-result');
            for (let i = 0; i < data.length; i++) {
                const newItem = document.importNode(template.content, true);
                const li = newItem.querySelector('li');
                const link = li.querySelector('a');
                const p = li.querySelector('p');
                link.href = data[i].url;
                setHighlightedText(link, stripHtml(data[i].title), currentTerm);
                link.classList.add('site-search-result--' + data[i].pageType.replace(/[0-9]/g, ''));
                p.textContent = stripHtml(data[i].preview);
                resultsContainer.append(newItem);
            }
            currentResultsCount = data.length;
            if (data.length > 0) resultsWrapper.classList.add('site-search__results-wrapper--show');
            else resultsWrapper.classList.remove('site-search__results-wrapper--show');
        };

        // ===== inline search / full results page =====
        function addInlineSearchEvents() {
            inlinesearchbox.addEventListener('keyup', function () {
                if (this.value.length > 2) {
                    gbg.Search.doSearch(this.value, 'full');
                    scheduleSearchTracking(this.value, 'inline');
                    if (!searchStarted) {
                        pushEvent('search_started', { search_term: this.value });
                        searchStarted = true;
                    }
                }
            });
        }
        function json(response) { return response.json(); }
        function drawSearchResultsFull(data) {
            inlineresultsbox.innerHTML = '';
            var res = '';
            var pageType = '';
            var types = [];
            data.forEach(function (obj) {
                pageType = obj.pageType.replace(/[0-9]/g, '');
                if (!types.includes(pageType)) types.push(pageType);
                const title = stripHtml(obj.title);
                res += '<p data-url="' + obj.url + '" data-title="' + escapeAttr(title) + '" data-pagetype="' + pageType + '">'
                    + '<span class="interactive-search-result__header">'
                    + '<a class="hd-xs" href="' + obj.url + '">' + title + '</a>'
                    + '<span class="result-type">' + pageType + '</span>'
                    + '</span><br />'
                    + '<span class="preview">' + stripHtml(obj.preview) + '</span><br />'
                    + '<span class="result-url">' + obj.url + '</span></p>';
            });
            if (res === '') res = '<p>Sorry, we couldn\'t find anything matching your search term. Please try a different search.</p>';
            var filterHolder = inlinesearchcontainer.querySelector('.filters');
            if (!filterHolder) {
                filterHolder = document.createElement('div');
                filterHolder.classList.add('filters');
            }
            filterHolder.innerHTML = '';
            var filterItem = document.createElement('input');
            filterItem.type = 'checkbox';
            filterItem.id = 'chkFilterAll';
            filterItem.value = 'All';
            filterItem.checked = true;
            filterItem.onclick = function () { gbg.Search.filterResults('All'); };
            var filterItemLabel = document.createElement('label');
            filterItemLabel.htmlFor = 'chkFilterAll';
            filterItemLabel.innerHTML = 'All';
            filterHolder.appendChild(filterItem);
            filterHolder.appendChild(filterItemLabel);
            types.forEach(function (type) {
                filterItem = document.createElement('input');
                filterItem.type = 'checkbox';
                filterItem.id = 'chkFilter' + type;
                filterItem.onclick = function () { gbg.Search.filterResults(type); };
                filterItem.value = type;
                filterItemLabel = document.createElement('label');
                filterItemLabel.htmlFor = 'chkFilter' + type;
                filterItemLabel.innerHTML = type;
                filterHolder.appendChild(filterItem);
                filterHolder.appendChild(filterItemLabel);
            });
            inlinesearchcontainer.appendChild(filterHolder);
            inlineresultsbox.innerHTML = res;
            inlinesearchcontainer.classList.remove('searching');
            currentInlineResultsCount = data.length;
        }
        function doSearch(searchstring, type) {
            currentInlineTerm = searchstring;
            var limiter = '';
            if (type === 'full') limiter = 'none';
            fetch('/umbraco/surface/sitesearchresults/getpages/?country=' + country + '&resultslimiter=' + limiter + '&searchstring=' + encodeURIComponent(searchstring))
                .then(json)
                .then(function (data) {
                    if (type === 'full') { drawSearchResultsFull(data); }
                })
                .catch(function (error) {
                    console.log('Request failed', error);
                });
        }
        function getParameterByName(name, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
        var filterResults = function (filter) {
            if (filter === 'All') {
                filters = [];
            } else {
                if (filters.includes(filter)) filters = filters.filter(f => f !== filter);
                else filters.push(filter);
            }
            if (filters.length === 0) {
                inlinesearchcontainer.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
                inlineresultsbox.querySelectorAll('p').forEach(p => p.className = '');
            } else {
                inlineresultsbox.querySelectorAll('p').forEach(p => {
                    p.className = filters.includes(p.dataset.pagetype) ? '' : 'hidden';
                });
            }
            document.getElementById('chkFilterAll').checked = filters.length === 0;
        };
        return {
            init: init,
            doSearch: doSearch,
            getResults: getResults,
            showResults: showResults,
            drawSearchResultsFull: drawSearchResultsFull,
            getParameterByName: getParameterByName,
            filterResults: filterResults
        };
    }());
    gbg.Search.init();
}());